import { apiClient } from "@/api";
import { TResponse } from "./chat-service";
import type {
  ProjectReportRes,
  EditReportRequest,
  ProjectShortlistRes,
} from "@/types/project";
import type { AxiosRequestConfig } from "axios";

export type { ProjectReportRes, EditReportRequest, ProjectShortlistRes };
export type { ShortlistData, ShortlistReadiness, ShortlistItem, LowScoreSection } from "@/types/project";

export const getProjectReport = (projectId: string, config?: AxiosRequestConfig) => {
  return apiClient.get<TResponse<ProjectReportRes>>(`/projects/${projectId}/report`, config);
};

export const editProjectReport = (req: EditReportRequest, config?: AxiosRequestConfig) => {
  return apiClient.put<TResponse<ProjectReportRes>>(`/projects/${req.project_id}/report`, {content: req.content}, config);
};

export const getProjectShortlist = (projectId: string, config?: AxiosRequestConfig) => {
  return apiClient.get<ProjectShortlistRes>(`/projects/${projectId}/shortlist`, config);
};
